import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { Box } from '@mui/material';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout/Layout';
import Dashboard from './pages/Dashboard/Dashboard';
import Clientes from './pages/Clientes/Clientes';
import Formulas from './pages/Formulas/Formulas';
import Pigmentos from './pages/Pigmentos/Pigmentos';
import FluxoCaixa from './pages/FluxoCaixa/FluxoCaixa';
import Orcamentos from './pages/Orcamentos/Orcamentos';
import Relatorios from './pages/Relatorios/Relatorios';
import Login from './pages/Login';

const theme = createTheme({
  palette: {
    primary: {
      main: '#2196f3',
    },
    secondary: {
      main: '#f50057',
    },
  },
  typography: {
    fontFamily: 'Roboto, Arial, sans-serif',
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={
              <ProtectedRoute>
                <Box sx={{ display: 'flex', minHeight: '100vh' }}>
                  <Layout>
                    <Dashboard />
                  </Layout>
                </Box>
              </ProtectedRoute>
            } />
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <Box sx={{ display: 'flex', minHeight: '100vh' }}>
                  <Layout>
                    <Dashboard />
                  </Layout>
                </Box>
              </ProtectedRoute>
            } />
            <Route path="/clientes" element={
              <ProtectedRoute>
                <Box sx={{ display: 'flex', minHeight: '100vh' }}>
                  <Layout>
                    <Clientes />
                  </Layout>
                </Box>
              </ProtectedRoute>
            } />
            <Route path="/formulas" element={
              <ProtectedRoute>
                <Box sx={{ display: 'flex', minHeight: '100vh' }}>
                  <Layout>
                    <Formulas />
                  </Layout>
                </Box>
              </ProtectedRoute>
            } />
            <Route path="/pigmentos" element={
              <ProtectedRoute>
                <Box sx={{ display: 'flex', minHeight: '100vh' }}>
                  <Layout>
                    <Pigmentos />
                  </Layout>
                </Box>
              </ProtectedRoute>
            } />
            <Route path="/fluxo-caixa" element={
              <ProtectedRoute>
                <Box sx={{ display: 'flex', minHeight: '100vh' }}>
                  <Layout>
                    <FluxoCaixa />
                  </Layout>
                </Box>
              </ProtectedRoute>
            } />
            <Route path="/orcamentos" element={
              <ProtectedRoute>
                <Box sx={{ display: 'flex', minHeight: '100vh' }}>
                  <Layout>
                    <Orcamentos />
                  </Layout>
                </Box>
              </ProtectedRoute>
            } />
            <Route path="/relatorios" element={
              <ProtectedRoute>
                <Box sx={{ display: 'flex', minHeight: '100vh' }}>
                  <Layout>
                    <Relatorios />
                  </Layout>
                </Box>
              </ProtectedRoute>
            } />
          </Routes>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
